import { useNavigate } from 'react-router-dom';
import type { FeaturedProduct } from '@/mocks/home';

interface FeaturedProductCardProps {
  product: FeaturedProduct;
}

export default function FeaturedProductCard({ product }: FeaturedProductCardProps) {
  const navigate = useNavigate();

  return (
    <div className="mx-3 mt-3 rounded-2xl overflow-hidden relative">
      {/* Red background header */}
      <div className="bg-gradient-to-br from-primary-500 to-primary-700 px-4 pt-3 pb-2">
        <div className="flex items-center gap-1.5">
          <i className="ri-star-fill text-yellow-400 text-sm" />
          <span className="text-white text-sm font-semibold">精选单品</span>
        </div>
      </div>

      {/* Product content */}
      <div className="bg-gradient-to-br from-primary-500 to-primary-700 px-4 pb-4">
        <div className="bg-white rounded-xl overflow-hidden">
          <div className="relative">
            <img
              src={product.image}
              alt={product.name}
              className="w-full aspect-square object-cover"
            />
            <span className="absolute top-2 left-2 px-2 py-0.5 bg-primary-500 text-white text-xs rounded-full font-medium">
              {product.tag}
            </span>
          </div>
          <div className="p-3">
            <h3 className="text-foreground-900 text-sm font-semibold">
              {product.name}
            </h3>
            <div className="flex items-end gap-2 mt-2">
              <span className="text-primary-500 text-lg font-bold">
                ¥{product.price.toLocaleString()}
              </span>
              <span className="text-foreground-400 text-xs line-through mb-0.5">
                ¥{product.originalPrice.toLocaleString()}
              </span>
              <span className="text-foreground-400 text-xs mb-0.5">
                /{product.unit}
              </span>
            </div>
            <button
              onClick={() => navigate('/purchase')}
              className="w-full mt-3 py-2.5 bg-primary-500 text-white text-sm font-medium rounded-lg active:bg-primary-600 transition-colors cursor-pointer"
            >
              立即购买
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}